module.exports = __webpack_public_path__ + "images/tips/more-help@2x.5ce82637804400767bea.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/tips/more-help@2x.png
// module id = 4tQ0
// module chunks = 13